import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import Text from 'components/Text';
import { Box } from 'reflexbox';
import { getText } from 'helpers/i18n';

import './addAllToBag.styles.scss';

import imgShoppingBag from 'images/buy-online-add-thin-24-white.svg';

export default class AddAllToBag extends Component {
    render() {
        const { products, addAllToBag, processing } = this.props;

        if (!window.Checkout.settings.allow_add_to_bag) {
            return null;
        }

        let availableProducts = 0;
        for (const product in products) {
            if (products[product].onlineSellable) {
                availableProducts++;
            }
        }

        if (availableProducts <= 1) {
            return null;
        }

        return (
            <Box mt={2} className="addalltobag">
                <p><Text textKey="addalltobag_headline" /></p>
                <Button
                    theme="primary"
                    text="addalltobag_button_label"
                    ariaLabel={getText('addalltobag_button_label')}
                    icon={imgShoppingBag}
                    isLoading={processing}
                    onClick={addAllToBag.bind(this, products)}
                />
            </Box>
        );
    }
}

AddAllToBag.propTypes = {
    products: PropTypes.object.isRequired,
    addAllToBag: PropTypes.func.isRequired,
    processing: PropTypes.bool,
};
